
export default {
    props:['error'],
    mounted() {
        console.log('error=', this.error)
    }
}
